/**
 * 描述：租户管理--预览logo
 * 日期：2018-3-12
 * 作者：lileilei
 */
"use strict";
angular.module('previewLogoModule', [])
    .controller('previewLogoCtrl', ['$scope', '$element', '$compile', '$rootScope', 'item', '$timeout', '$modalInstance', function($scope, $element, $compile, $rootScope, item, $timeout, $modalInstance) {
        initData();
        /**
         * [initData description: 初始化数据]
         * @return {[type]}          [description]
         */
        function initData() {
            $scope.headerLogoUrl = item.url;
            $scope.name = item.name;
            $timeout(function() {
                var spanCancel = $compile($("<div ng-click='cancel()' class='cancel'><span class='close' ng-click='close()'></span></div>"))($scope);
                $element.prepend(spanCancel);
            });
        }
        $scope.cancel = function() { //新追加的节点上的方法不起作用的解决方法
            $modalInstance.dismiss();
        }
    }]);